
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const TermsPage: React.FC = () => {
  return (
    <div className="terms-page py-5">
      <Container>
        <Row>
          <Col lg={8} className="mx-auto">
            <h1 className="mb-4">Terms and Conditions</h1>
            <p className="text-muted mb-4">Last updated: {new Date().toLocaleDateString()}</p>
            
            <section className="mb-5">
              <h2 className="h4 mb-3">1. Acceptance of Terms</h2>
              <p>
                By accessing and using MyWeeshy (operated by Deviofy FZCO), you accept and agree to be bound by the terms and provision of this agreement. 
                If you do not agree to abide by the above, please do not use this service.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">2. Description of Service</h2>
              <p>
                MyWeeshy is a platform that enables DJs to receive song requests and donations from their audience. 
                The service includes event management, request handling, and payment processing features.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">3. User Accounts</h2>
              <p>
                Users must register for an account to access certain features. You are responsible for maintaining the confidentiality 
                of your account information and for all activities that occur under your account.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">4. Payment Terms</h2>
              <p>
                Premium features require payment. All fees are non-refundable unless otherwise stated. 
                We reserve the right to change our pricing at any time with reasonable notice.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">5. User Conduct</h2>
              <p>
                Users agree not to use the service for any unlawful purpose or in any way that could damage, 
                disable, or impair the service. Harassment, spam, or inappropriate content is prohibited.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">6. Intellectual Property</h2>
              <p>
                The service and its original content, features, and functionality are owned by Deviofy FZCO and are protected 
                by international copyright, trademark, patent, trade secret, and other intellectual property laws.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">7. Limitation of Liability</h2>
              <p>
                In no event shall Deviofy FZCO be liable for any indirect, incidental, special, consequential, 
                or punitive damages arising out of your use of the service.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">8. Termination</h2>
              <p>
                We may terminate or suspend your account immediately, without prior notice or liability, 
                for any reason whatsoever, including without limitation if you breach the Terms.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">9. Changes to Terms</h2>
              <p>
                We reserve the right to modify these terms at any time. We will notify users of any changes 
                by posting the new Terms and Conditions on this page.
              </p>
            </section>

            <section className="mb-5">
              <h2 className="h4 mb-3">10. Contact Information</h2>
              <p>
                If you have any questions about these Terms and Conditions, please contact us at:
              </p>
              <address>
                <strong>Deviofy FZCO</strong><br />
                DSO-THUB, Dubai Digital Park<br />
                Dubai Silicon Oasis, Building A2<br />
                Dubai, UAE<br />
                <a href="mailto:info@deviofy.com">info@deviofy.com</a>
              </address>
            </section>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default TermsPage;
